import { render } from "./ProjectFormV2.vue?vue&type=template&id=3cc80ed8"
import script from "./ProjectFormV2.vue?vue&type=script&lang=js"
export * from "./ProjectFormV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__